// removed by extract-text-webpack-plugin
module.exports = {"container":"RequestMoreImages-style__container__95439f0f","header":"RequestMoreImages-style__header__95439f0f","subheader":"RequestMoreImages-style__subheader__95439f0f","icon":"RequestMoreImages-style__icon__95439f0f","link":"RequestMoreImages-style__link__95439f0f","buttonContainer":"RequestMoreImages-style__buttonContainer__95439f0f","socialIconsContainer":"RequestMoreImages-style__socialIconsContainer__95439f0f"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Carousel/RequestMoreImages/RequestMoreImages-style.scss
// module id = 2265
// module chunks = 7